var App = App || {};

App.LightboxVideo = (function ($) {
	"use strict";

	function init() {
		var $videoModal = $("#LightboxVideo_Modal");

		var $iframe = $videoModal.find('iframe');
		var $videoTitle = $videoModal.find('.modal-title');

		$("body").on('click', 'a.lightbox-video', function () {
			var $this = $(this),
				src = $this.data('video') + '?autoplay=1&rel=0',
				videoTitle = $this.data('title');

			$iframe.attr('src', src);
			$videoTitle.html(videoTitle);
		});

		$videoModal.on('hide.bs.modal', function () {
			$iframe.attr('src', '');
		});
	}

	return {
		init: init
	};
})(jQuery);

$(function () {
	App.LightboxVideo.init();
});